import React, { useMemo, useRef, useState } from "react";
import "./arrearageminder.css";

import { DynamicTabb } from "../../components/DynamicTab/DynamicTab";
import axios from "axios";
import CustomStore from "devextreme/data/custom_store";

import DataGrid, {
  Column,
  Paging,
  Pager,
  Scrolling,
  LoadPanel,
  HeaderFilter,
  ColumnChooser,
  FilterRow,
  Search,
  StateStoring,
  TotalItem,
  Summary,
} from "devextreme-react/data-grid";

import { Popup } from "devextreme-react";
import { ContextMenu } from "devextreme-react/context-menu";

import { handleGetLocal } from "../../services/auth-service";
import { Tablecoloum } from "./Data";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { logOut } from "../../components/Logout";
import { setTableData } from "./Functions";

import { SendEmail } from "../Participants/HeaderPopupComponent/SendEmail";
import { Toster } from "../../components/Toster/Toster";
import { AddFilterPopup } from "../../components/EditfilterPopup.js/AddFilterPopup";
import ThreeDotMenu from "../../components/Common/Icons/ThreeDotMenu";
import { setDynamicTab } from "../../reducer/HomePageReducer";

export const ArrearageMinder = () => {
  const pathname = handleGetLocal("pathURL");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const arrearageGridRef = useRef(null);

  const [exportPopupOpen, setexportPopupOpen] = useState(false);

  const arrearageRowDataRef = useRef(null);

  const [sendEmailPopup, setSendEmailPopup] = useState(false);

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const [getCustomFilterValue, setgetCustomFilterValue] = useState([]);
  const [emailRowData, setEmailRowData] = useState(null);
  const headerFilterTimerRef = useRef({});
  const [filterRowVisible, setFilterRowVisible] = useState(false);
  const [headerFilterVisible, setHeaderFilterVisible] = useState(true);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const lastArrearageRequestRef = useRef({
    key: null,
    result: null,
  });

  const arrearageStore = useMemo(() => {
    return new CustomStore({
      key: "Client Id",

      load: async (loadOptions) => {
        try {
          const pageSize = loadOptions.take || 25;
          const page = Math.floor((loadOptions.skip || 0) / pageSize) + 1;

          const params = {
            page,
            pageSize,
            filter: loadOptions.filter ? JSON.stringify(loadOptions.filter) : undefined,
            sort: loadOptions.sort?.length ? JSON.stringify(loadOptions.sort) : undefined,
          };
          const requestKey = JSON.stringify(params);

          if (lastArrearageRequestRef.current.key === requestKey && lastArrearageRequestRef.current.result) {
            return lastArrearageRequestRef.current.result;
          }

          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/arrearage-minder/get-arrearage-minder`,
            {
              params,
              headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                Domain: pathname,
              },
            },
          );
          if (!response.data?.isSuccess) {
            throw new Error(response.data?.message || "Failed to load arrearage data");
          }

          const result = response?.data?.data;

          const storeResult = {
            data: setTableData(result?.items || []),
            totalCount: result?.totalCount ?? 0,
            summary: [
              result?.totalCount ?? 0,
              result?.totalAmount ?? 0,
              result?.totalBalance ?? 0,
              result?.totalArrears ?? 0,
              result?.totalPendingCC ?? 0,
            ],
          };

          lastArrearageRequestRef.current = {
            key: requestKey,
            result: storeResult,
          };

          return storeResult;
        } catch (error) {
          if (error?.response?.status === 401) {
            logOut();
          } else if (!error?.response) {
            navigate("/error/500");
          }

          throw error;
        }
      },
    });
  }, [pathname, navigate]);
  const refreshArrearageGrid = () => {
    lastArrearageRequestRef.current = {
      key: null,
      result: null,
    };

    arrearageGridRef.current?.instance()?.refresh();
  };
  const jumpToPerson = (rowData) => {
    const clientId = rowData?.["Client Id"];

    if (!clientId) {
      return;
    }

    dispatch(
      setDynamicTab({
        link: `/participant/${clientId}`,
        Offender: clientId,
        title: rowData?.["Client Name"]?.split(",")[0],
      }),
    );

    navigate(`/participant/${clientId}`);
  };
  const sendArrearageNotification = (rowData) => {
    if (!rowData?.["Client Id"]) {
      return;
    }

    setEmailRowData(rowData);
    setSendEmailPopup(true);
  };

  const removeCurrentColumnFilter = (filter, columnName) => {
    if (!Array.isArray(filter)) {
      return filter;
    }
    if (filter[0] === "!") {
      const inner = removeCurrentColumnFilter(filter[1], columnName);

      return inner === null ? null : ["!", inner];
    }
    if (
      filter.length === 3 &&
      typeof filter[0] === "string" &&
      typeof filter[1] === "string" &&
      !["and", "or"].includes(filter[1])
    ) {
      return filter[0] === columnName ? null : filter;
    }
    const conditions = [];

    for (let i = 0; i < filter.length; i += 2) {
      const condition = removeCurrentColumnFilter(filter[i], columnName);

      if (condition !== null) {
        conditions.push({
          condition,
          operator: i > 0 ? filter[i - 1] : null,
        });
      }
    }

    if (conditions.length === 0) {
      return null;
    }

    let result = conditions[0].condition;

    for (let i = 1; i < conditions.length; i++) {
      result = [result, conditions[i].operator || "and", conditions[i].condition];
    }

    return result;
  };

  const getHeaderFilterDataSource = (field) => (options) => {
    const grid = arrearageGridRef.current?.instance();
    const currentFilter = grid?.getCombinedFilter(true);

    const columnNameMap = {
      status: "Status",
      text: "Text",
      email: "Email",
      splitfee: "Split Fee",
      clientid: "Client Id",
      clientname: "Client Name",
      amount: "Amount",
      balance: "Balance",
      arrears: "Arrears",
      pendingcc: "Pending CC",
      courtagency: "Court/Agency",
      daysaheadbehind: "Days Ahead/Behind",
      company: "Company",
      region: "Region",
      lastpayment: "Last Payment",
      compliancelevel: "Compliance Level",
      supervisor: "Supervisor",
      lastarrearagenote: "Last Arrearage Note",
    };

    const currentColumn = columnNameMap[field];

    const filteredExpression = currentColumn ? removeCurrentColumnFilter(currentFilter, currentColumn) : currentFilter;
    console.log("Header filter field:", field);
    console.log("Current grid filter:", currentFilter);
    console.log("Filter sent to API:", filteredExpression);
    options.dataSource = {
      store: new CustomStore({
        key: "value",
        useDefaultSearch: false,

        load: async (loadOptions) => {
          try {
            console.log("Header filter loadOptions:", loadOptions);

            const search = String(loadOptions.searchValue ?? "").trim();

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/arrearage-minder/header-filter`, {
              params: {
                field,
                search: search || undefined,
                filter: filteredExpression ? JSON.stringify(filteredExpression) : undefined,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                Domain: pathname,
              },
            });

            if (!response.data?.isSuccess) {
              throw new Error(response.data?.message || "Unable to load header filter values");
            }

            const booleanFields = ["text", "email", "splitfee"];

            const numericFields = ["amount", "balance", "arrears", "pendingcc", "daysaheadbehind"];

            return (response.data?.data || []).map((value) => {
              if (booleanFields.includes(field)) {
                const boolValue = String(value).toLowerCase() === "true";

                return {
                  text: boolValue ? "True" : "False",
                  value: boolValue,
                };
              }

              if (numericFields.includes(field)) {
                const numericValue = Number(value);

                if (field === "daysaheadbehind") {
                  return {
                    text: String(value),
                    value: numericValue,
                  };
                }

                return {
                  text: numericValue.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
                  value: numericValue,
                };
              }

              if (field === "lastpayment") {
                return {
                  text: value,
                  value: value,
                };
              }

              return {
                text: value === null || value === "" ? "(Blanks)" : value,
                value: value === null || value === "" ? null : value,
              };
            });
          } catch (error) {
            if (error?.response?.status === 401) {
              logOut();
            }

            throw error;
          }
        },
      }),

      searchExpr: "text",
      searchOperation: "contains",
      paginate: false,
    };
  };
  return (
    <>
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <Popup
        visible={sendEmailPopup}
        onHiding={() => {
          setSendEmailPopup(false);
        }}
        showTitle={false}
        width={1180}
        height={822}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <SendEmail
          recivePaymentModel={sendEmailPopup}
          setRecivePaymentModel={setSendEmailPopup}
          userinfo={emailRowData}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          documentWizrard={true}
        />
      </Popup>

      <Popup
        visible={isPopupVisible}
        onHiding={() => setIsPopupVisible(false)}
        showTitle={false}
        width={700}
        height={400}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddFilterPopup
          setIsPopupVisible={setIsPopupVisible}
          Tablecoloum={Tablecoloum}
          setgetCustomFilterValue={setgetCustomFilterValue}
        />
      </Popup>

      <div className="arrearageminderMainTabWrapper">
        <div className="tabwapper">
          <DynamicTabb />

          <div className="tab-main-box">
            <div className="tab-box" id="tab-1">
              <p>Arrearage minder tab content/design will be here</p>
            </div>

            <div className="tab-box" id="tab-2" style={{ display: "block" }}>
              <div className="tabcontent">
                <div className="screen_num">
                  <p>OB.20</p>
                </div>

                <div
                  className="interaction flex"
                  style={{
                    gap: "50px",
                    alignItems: "center",
                  }}
                >
                  <div className="leftAction leftAlign">
                    <button
                      onClick={() => {
                        setexportPopupOpen(true);
                      }}
                      id="myBtn"
                      className="btn btnlightblue"
                    >
                      Export
                      <svg
                        className="svg-blue-white"
                        width="14"
                        height="17"
                        viewBox="0 0 14 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.59 6H10V1C10 0.45 9.55 0 9 0H5C4.45 0 4 0.45 4 1V6H2.41C1.52 6 1.07 7.08 1.7 7.71L6.29 12.3C6.68 12.69 7.31 12.69 7.7 12.3L12.29 7.71C12.92 7.08 12.48 6 11.59 6ZM0 16C0 16.55 0.45 17 1 17H13C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15H1C0.45 15 0 15.45 0 16Z"
                          fill="#424167"
                        />
                      </svg>
                    </button>

                    <button onClick={refreshArrearageGrid} className="btn btnlightblue">
                      Refresh
                      <svg
                        className="svg-blue-white"
                        width="16"
                        height="21"
                        viewBox="0 0 16 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.99905 4.00003V1.21003C7.99905 0.760031 7.45905 0.540031 7.14905 0.860031L3.34905 4.65003C3.14905 4.85003 3.14905 5.16003 3.34905 5.36003L7.13905 9.15003C7.45905 9.46003 7.99905 9.24003 7.99905 8.79003V6.00003C11.7291 6.00003 14.6791 9.42003 13.8591 13.29C13.3891 15.56 11.5491 17.39 9.28905 17.86C5.71905 18.61 2.53905 16.16 2.05905 12.85C1.98905 12.37 1.56905 12 1.07905 12C0.479051 12 -0.000948563 12.53 0.0790514 13.13C0.699051 17.52 4.87905 20.77 9.60905 19.85C12.7291 19.24 15.2391 16.73 15.8491 13.61C16.8391 8.48003 12.9391 4.00003 7.99905 4.00003Z"
                          fill="#424167"
                        />
                      </svg>
                    </button>

                    <button
                      id="myBtn"
                      onClick={() => {
                        setIsPopupVisible(!isPopupVisible);
                      }}
                      style={{
                        color: getCustomFilterValue.length >= 1 ? "white" : undefined,
                      }}
                      className={getCustomFilterValue.length >= 1 ? "btn blue" : "btn btnlightblue"}
                    >
                      {getCustomFilterValue.length >= 1 ? "Edit Filter" : "Add Filter"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="Detail_Contact_Tab">
              <div
                style={{
                  marginTop: "1.5%",
                  width: "100%",
                }}
              >
                <div className="arrearage-grid-options">
                  <button
                    type="button"
                    className="arrearage-column-chooser-btn"
                    title="Column Chooser"
                    onClick={() => {
                      arrearageGridRef.current?.instance()?.showColumnChooser();
                    }}
                  >
                    <i className="dx-icon-column-chooser"></i>
                  </button>
                  <div className="arrearage-apply-filter-label">
                    Apply
                    <br />
                    Filter
                  </div>
                  <select className="arrearage-apply-filter-select" value="Immediately" disabled>
                    <option value="Immediately">Immediately</option>
                  </select>
                  <label className="arrearage-filter-option">
                    <input
                      type="checkbox"
                      checked={filterRowVisible}
                      onChange={(e) => {
                        setFilterRowVisible(e.target.checked);
                      }}
                    />

                    <span>
                      Filter
                      <br />
                      Row
                    </span>
                  </label>
                  <label className="arrearage-filter-option">
                    <input
                      type="checkbox"
                      checked={headerFilterVisible}
                      onChange={(e) => {
                        setHeaderFilterVisible(e.target.checked);
                      }}
                    />

                    <span>
                      Header
                      <br />
                      Filter
                    </span>
                  </label>
                </div>
                <DataGrid
                  ref={arrearageGridRef}
                  id="arrearageMinderGrid"
                  dataSource={arrearageStore}
                  keyExpr="Client Id"
                  showBorders={true}
                  showRowLines={true}
                  showColumnLines={true}
                  rowAlternationEnabled={true}
                  hoverStateEnabled={true}
                  columnAutoWidth={false}
                  allowColumnResizing={true}
                  allowColumnReordering={true}
                  columnResizingMode="widget"
                  wordWrapEnabled={false}
                  width="100%"
                  height="calc(100vh - 300px)"
                  remoteOperations={{
                    paging: true,
                    filtering: true,
                    summary: true,
                    sorting: true,
                  }}
                  onContextMenuPreparing={(e) => {
                    if (e.row?.rowType === "data") {
                      arrearageRowDataRef.current = e.row.data;
                    }
                  }}
                >
                  <StateStoring
                    enabled={true}
                    type="localStorage"
                    storageKey={`arrearageMinderGridState_${pathname}`}
                  />
                  <Summary>
                    <TotalItem column="Client Name" summaryType="count" displayFormat="Count: {0}" />

                    <TotalItem column="Amount" summaryType="sum" valueFormat={{ type: "currency", precision: 2 }} />

                    <TotalItem column="Balance" summaryType="sum" valueFormat={{ type: "currency", precision: 2 }} />

                    <TotalItem column="Arrears" summaryType="sum" valueFormat={{ type: "currency", precision: 2 }} />

                    <TotalItem column="Pending CC" summaryType="sum" valueFormat={{ type: "currency", precision: 2 }} />
                  </Summary>
                  <LoadPanel enabled={true} showPane={true} showIndicator={true} />
                  <FilterRow visible={filterRowVisible} applyFilter="auto" />

                  <HeaderFilter visible={true} allowSearch={true} width={350} height={450} />

                  <ColumnChooser height="340px" width="400px" enabled={true} mode="dragAndDrop" />

                  <Paging defaultPageSize={25} defaultPageIndex={0} />

                  <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[25, 50, 100]}
                    showInfo={true}
                    showNavigationButtons={true}
                    displayMode="full"
                  />
                  <Scrolling mode="standard" showScrollbar="always" useNative={false} />
                  <Column
                    caption=""
                    width={50}
                    allowReordering={false}
                    allowSorting={false}
                    allowFiltering={false}
                    allowHeaderFiltering={false}
                    fixed={true}
                    fixedPosition="left"
                    cellRender={(rowData) => {
                      return (
                        <div
                          className="add_navBar_hamburger arrearage-three-dot"
                          onClick={() => {
                            arrearageRowDataRef.current = rowData.data;
                          }}
                        >
                          <ThreeDotMenu />
                        </div>
                      );
                    }}
                  />

                  <Column
                    dataField="Status"
                    caption="Status"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("status"),
                    }}
                  />

                  <Column
                    dataField="Text"
                    caption="Text"
                    dataType="boolean"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("text"),
                    }}
                  />

                  <Column
                    dataField="Email"
                    caption="Email"
                    dataType="boolean"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("email"),
                    }}
                  />

                  <Column
                    dataField="Split Fee"
                    caption="Split Fee"
                    dataType="boolean"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("splitfee"),
                    }}
                  />

                  <Column
                    dataField="Client Id"
                    caption="Client Id"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("clientid"),
                    }}
                  />

                  <Column
                    dataField="Client Name"
                    caption="Client Name"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("clientname"),
                    }}
                  />
                  <Column
                    dataField="Amount"
                    caption="Amount"
                    dataType="number"
                    alignment="right"
                    format={{ type: "currency", precision: 2 }}
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("amount"),
                    }}
                  />

                  <Column
                    dataField="Balance"
                    caption="Balance"
                    dataType="number"
                    alignment="right"
                    format={{ type: "currency", precision: 2 }}
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("balance"),
                    }}
                  />

                  <Column
                    dataField="Arrears"
                    caption="Arrears"
                    dataType="number"
                    alignment="right"
                    format={{ type: "currency", precision: 2 }}
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("arrears"),
                    }}
                  />

                  <Column
                    dataField="Pending CC"
                    caption="Pending CC"
                    dataType="number"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("pendingcc"),
                    }}
                  />

                  <Column
                    dataField="Court/Agency"
                    caption="Court/Agency"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("courtagency"),
                    }}
                  />

                  <Column
                    dataField="Days Ahead/Behind"
                    caption="Days Ahead/Behind"
                    dataType="number"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("daysaheadbehind"),
                    }}
                  />

                  <Column
                    dataField="Company"
                    caption="Company"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("company"),
                    }}
                  />

                  <Column
                    dataField="Region"
                    caption="Region"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("region"),
                    }}
                  />

                  <Column
                    dataField="Last Payment"
                    caption="Last Payment"
                    dataType="date"
                    format="MM/dd/yyyy"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("lastpayment"),
                    }}
                  />

                  <Column
                    dataField="Compliance Level"
                    caption="Compliance Level"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("compliancelevel"),
                    }}
                  />

                  <Column
                    dataField="Supervisor"
                    caption="Supervisor"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("supervisor"),
                    }}
                  />

                  <Column
                    dataField="Last Arrearage Note"
                    caption="Last Arrearage Note"
                    width="auto"
                    headerFilter={{
                      dataSource: getHeaderFilterDataSource("lastarrearagenote"),
                    }}
                  />
                </DataGrid>
                <ContextMenu
                  showEvent="dxclick"
                  target=".arrearage-three-dot"
                  dataSource={[
                    {
                      text: "Jump to Person",
                      icon: "search",
                    },
                    {
                      text: "Send Arrearage Notification",
                      icon: "email",
                    },
                  ]}
                  onItemClick={(e) => {
                    const selectedRow = arrearageRowDataRef.current;

                    if (!selectedRow) {
                      return;
                    }

                    if (e.itemData.text === "Jump to Person") {
                      jumpToPerson(selectedRow);
                    } else if (e.itemData.text === "Send Arrearage Notification") {
                      sendArrearageNotification(selectedRow);
                    }
                  }}
                />
                <ContextMenu
                  showEvent="dxcontextmenu"
                  target="#arrearageMinderGrid .dx-data-row"
                  dataSource={[
                    {
                      text: "Jump to Person",
                      icon: "search",
                    },
                    {
                      text: "Send Arrearage Notification",
                      icon: "email",
                    },
                  ]}
                  onItemClick={(e) => {
                    const selectedRow = arrearageRowDataRef.current;

                    if (!selectedRow) {
                      return;
                    }

                    if (e.itemData.text === "Jump to Person") {
                      jumpToPerson(selectedRow);
                    } else if (e.itemData.text === "Send Arrearage Notification") {
                      sendArrearageNotification(selectedRow);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
